var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 270,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    y2: "96.7175267%",
    x2: "50%",
    y1: "-352.925786%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#002E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#002639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    y2: "428.758892%",
    x2: "50%",
    y1: "-2.80786187%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#002E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#002639"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient-3",
    r: "295.57111%",
    fy: "142.999709%",
    fx: "16.4234038%",
    cy: "142.999709%",
    cx: "16.4234038%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00BC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#149D91"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient-4",
    r: "357.003966%",
    fy: "-42.999755%",
    fx: "16.423338%",
    cy: "-42.999755%",
    cx: "16.423338%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00BC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#149D91"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient-5",
    r: "343.189366%",
    fy: "-40.4580495%",
    fx: "11.4670327%",
    cy: "-40.4580495%",
    cx: "11.4670327%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#004473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00345F"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#radialGradient-5)",
    transform: "rotate(89.6792, 216.52, 135.192)",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "url(#linearGradient-1)",
    d: "m154.69923,253.30064l-65.5915,32.0838l127.29256,62.0004l127.63905,-62.19503l-65.75882,-32.53854l-61.92847,30.75344l-61.65282,-30.10407z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "url(#linearGradient-2)",
    d: "m146.602,21.17488l0,-0.0207l69.92927,-34.10654l69.93444,34.10654l57.53818,-35.95554l-127.51919,-62.19864l-127.4847,62.17966l0,0.0552l57.5537,35.96416l0.0483,-0.02414l0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "url(#radialGradient-3)",
    d: "m89.15618,221.42843l62.91498,-30.80379l64.71363,32.04262l-127.62861,62.79471l0,-64.03354z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "url(#radialGradient-4)",
    d: "m285.67754,22.41032c0,33.58917 0,100.76752 0,100.76752l-70.34128,34.4238l64.68617,32.33897l62.97849,-30.79688l-0.00001,-173.95295l-57.32337,35.97581l0,1.24373z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "url(#radialGradient-5)",
    d: "m344.00389,221.2165l-197.41491,-98.25059l0,-101.78437l-57.58898,-35.9513l0,0.90728l0,172.79428l255.00389,126.32169l0,-64.03699z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#002e3b",
    strokeWidth: "1mm",
    stroke: "#002e3b",
    fontSize: "9pt",
    fillRule: "evenodd",
    strokeLinecap: "round",
    id: "svgGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    vectorEffect: "non-scaling-stroke",
    d: "m264.136,172.6l-12.852,0l-13.284,-75.6l7.02,0l12.096,71.496l1.296,0l15.66,-71.496l12.744,0l15.66,71.496l1.296,0l12.096,-71.496l7.02,0l-13.284,75.6l-12.852,0l-15.66,-71.496l-1.296,0l-15.66,71.496z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df21222c045270b15dcf544abe1c6f11.svg";
export { ForwardRef as ReactComponent };